import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { CompanyStore } from './company-stores.models';

export const CompanyStoresActions = createActionGroup({
  source: 'Company Stores',
  events: {
    Load: emptyProps(),
    Select: props<{ storeUuid: string }>(),
    'Redirect And Select Store': props<{ storeUuid: string }>(),
    'Redirect To Self Ordering': props<{ storeUuid: string }>(),
  },
});

export const CompanyStoresApiActions = createActionGroup({
  source: 'Company Stores API',
  events: {
    'Load Success': props<{ stores: Array<CompanyStore> }>(),
    'Load Failure': emptyProps(),
  },
});
